import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output';

const Resume5 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="max-w-[8.27in] mx-auto my-10 bg-white shadow-lg rounded-lg border border-gray-300 overflow-hidden" ref={resumeRef}>
        <div className="bg-[#2c3e50] text-white p-6 flex justify-between items-center">
          <div className="flex items-center">
            <img
              className="w-30 h-30 rounded-full object-cover mr-4"
              src={ResumeStore?.resumeBuilder.profile || 'https://via.placeholder.com/150'}
              alt="Profile Picture"
              width={150}
              height={150}
            />
            <div>
              <h1 className="text-2xl font-bold">{ResumeStore?.resumeBuilder.personalDetails.firstName} {ResumeStore?.resumeBuilder.personalDetails.lastName}</h1>
              <h2 className="text-xl">{ResumeStore?.resumeBuilder.personalDetails.jobTitle}</h2>
            </div>
          </div>
        </div>
        <div className="flex">
          <div className="bg-[#ecf0f1] p-6 w-1/3">
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-[#2c3e50] border-b-2 border-[#bdc3c7] pb-2">Personal Profile</h2>
              <p>{ResumeStore?.resumeBuilder.profileSummary}</p>
            </div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-[#2c3e50] border-b-2 border-[#bdc3c7] pb-2">Contact</h2>
              <p>{ResumeStore?.resumeBuilder.personalDetails.address}</p>
              <p>{ResumeStore?.resumeBuilder.personalDetails.email}</p>
              <p>{ResumeStore?.resumeBuilder.personalDetails.phone}</p>
            </div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-[#2c3e50] border-b-2 border-[#bdc3c7] pb-2">Work Experience</h2>
              {ResumeStore?.resumeBuilder.employementHistory.map((job, index) => (
                <div key={index} className="mb-4">
                  <p>{job.jobTitle}, {job.company} <br />{job.startDate} - {job.endDate}</p>
                  <ul className="list-disc pl-4">
                    {job.description?.split('\n')?.map((desc, idx) => (
                      <li key={idx}>{desc}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
          <div className="p-6 w-2/3">
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-[#2c3e50] border-b-2 border-[#bdc3c7] pb-2">Skills</h2>
              <ul className="list-disc pl-4">
                {ResumeStore?.resumeBuilder.skills.map((skill, index) => (
                  <li key={index}>{skill}</li>
                ))}
              </ul>
            </div>
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-[#2c3e50] border-b-2 border-[#bdc3c7] pb-2">Education</h2>
              {ResumeStore?.resumeBuilder.education.map((edu, index) => (
                <>
                  <h3 className="text-lg font-semibold">{edu.school}, {edu.degree}</h3>
                  <p key={index}>{edu.startDate} - {edu.endDate}</p>
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  ));
}

export default Resume5;
